import { render } from "./ExerciceWordToImages.vue?vue&type=template&id=7bae0e84&scoped=true"
import script from "./ExerciceWordToImages.vue?vue&type=script&lang=js"
export * from "./ExerciceWordToImages.vue?vue&type=script&lang=js"

import "./ExerciceWordToImages.vue?vue&type=style&index=0&id=7bae0e84&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-7bae0e84"

export default script